import React from "react";

const MyLoader = ({ text }) => {
  return (
    <div>
      <h1 className="h1 t-center">{text}</h1>
    </div>
  );
};

export default MyLoader;
